<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>{{ title }}</template>
    <template #content>
      <el-form ref="form" :model="form" label-width="90px">
        <el-form-item :label="label"
                      prop="reason"
                      :rules="[{ required: true, message: '不能为空' ,trigger: ['blur', 'change']},
                               { max: 200, message: '长度不能大于200个字符', trigger: ['blur', 'change'] }]">
          <gj-textarea
              v-model="form.reason"
              :styles="{height: '120px', width: '340px'}"
              placeholder="不能超过两百个字符"
              class="form-input">
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";
import {
  postReviewNoPass,
  postReviewAbort
} from "@/api/logistics";
import {defaultVal} from "@/utils/common";

export default {
  name: "delivery-plan-confirm",
  mixins: [modalMixIn],
  props: {
    type: {
      required: true
    },
    rows: {
      required: true
    },
    title: {
      required: true
    },
    label: {
      required: true
    }
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        reason: null
      }
    }
  },
  methods: {
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            idList: this.rows.map(v => v.id),
            reason: this.form.reason,
          };
          if (this.type === 'rejected') {
            this.confirmLoading = true;
            postReviewNoPass(params)
                .then(() => {
                  this.$emit('updated');
                  this.$gjDestroy();
                })
                .complete(() => this.confirmLoading = false);
          } else {
            postReviewAbort(params)
                .then(() => {
                  this.$emit('updated');
                  this.$gjDestroy();
                })
                .complete(() => this.confirmLoading = false);
          }
        }
      });
    }
  }
}
</script>

<style scoped>
.form-input {

}
</style>
